export { default } from "./src/hero-intro";
export type { UniformHeroIntroProps } from "./src/hero-intro";
